/*
 * View for the modal where you create the name of a new quick-create topic
 */

define([
  "marionette",
  "modules/quickCreate/quickTopicModal/template/quickTopicModalTemplate.html",
], function (Marionette, QuickTopicModalTemplate) {
  var QuickTopicModalView = {};

  QuickTopicModalView.quickTopicModalView = Marionette.ItemView.extend({
    template: QuickTopicModalTemplate,
    getTopicName: function () {
      //get the name from the input element
      return this.$el.find("#topicName").val();
    },
    showError: function (errorMessage) {
      this.$el
        .find("#error")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return QuickTopicModalView;
});
